import { ContractMeetingStateTypes, ContractMeetingActionTypes } from "./ContractMeeting.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ContractMeetingStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ContractMeetingReducer = (
  state: ContractMeetingStateTypes = INITIAL_STATE,
  action: any
): ContractMeetingStateTypes => {
  switch (action.type) {
    case ContractMeetingActionTypes.FETCH_ALL_CONTRACT_MEETING:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ContractMeetingActionTypes.FETCH_ALL_CONTRACT_MEETING_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ContractMeetingActionTypes.FETCH_ALL_CONTRACT_MEETING_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ContractMeetingActionTypes.FETCH_ALL_CONTRACT_MEETING_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ContractMeetingActionTypes.FETCH_ONE_CONTRACT_MEETING:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ContractMeetingActionTypes.FETCH_ONE_CONTRACT_MEETING_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState({}),
      };
    case ContractMeetingActionTypes.FETCH_ONE_CONTRACT_MEETING_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ContractMeetingActionTypes.FETCH_ONE_CONTRACT_MEETING_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ContractMeetingReducer;
